export enum ProductType {
  Casino = 1,
  Sports = 2,
  Poker = 3,
  Lottery = 4,
  Pools = 5,
  Virtuals = 6,
  Payments = 7,
}
